// extracted by mini-css-extract-plugin
export var modalFooter = "_sl-0";